module.exports = __webpack_public_path__ + "asset/image/mail-aa4f.svg";